import { toast } from "react-toastify";
import i18n from "locales/i18n";

/**
 * Error handler function for React Query.
 * Can be used to handle query and mutation errors globally.
 * @param {unknown} error - The error object or message.
 */
export const errorHandler = (error: unknown) => {
	console.error("Error occurred:", error);
	if (error instanceof Error) {
		toast.error(i18n.t("errors.genericError", { message: error.message }));
	} else {
		toast.error(i18n.t("errors.unexpectedError"));
	}
};

/**
 * Success handler function for React Query.
 * Can be used to handle successful mutations globally.
 * @param {unknown} data - The data returned by the successful mutation.
 */
export const successHandler = (data: unknown) => {
	console.log("Success:", data);
	toast.success(i18n.t("errors.operationSuccess"));
};
